module.exports = __webpack_public_path__ + "media/images/mail-4b50710f.svg";